export default "__VITE_ASSET__BfbGq_Ss__"